module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1053.8e426bab.jpg";